import { FunctionComponent } from 'react';
import FlagOutlined from '@mui/icons-material/FlagOutlined';
import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined';
import '../../../css/PublicAboutUsPage.css';

const Component02: FunctionComponent = () => {
  return (
    <div className='public-about-us-page-component-two-container vdr-about-panel'>
      <div className='vdr-section-head vdr-about-section-head'>
        <h2 className='public-about-us-page-subtitle-text'>Misión y Visión</h2>
        <small>Propósito</small>
      </div>
      <div className='vdr-about-sheet'>
        <div className='vdr-about-sheet-row'>
          <span className='vdr-icon-tile' aria-hidden='true'>
            <FlagOutlined />
          </span>
          <div>
            <h3 className='vdr-about-sheet-label'>Misión:</h3>
            <p className='public-about-us-page-text'>
              Nuestra misión es ofrecer soluciones tecnológicas integrales para la gestión y
              análisis de redes de distribución eléctrica, facilitando la toma de decisiones
              informadas a través de herramientas innovadoras y fáciles de usar. Buscamos
              incrementar la visibilidad de las redes de distribución y el acceso a información
              relevante que facilite la planificación de las redes y el desarrollo de proyectos de
              generación distribuida, promoviendo la transición energética y la resiliencia de
              nuestras redes.
            </p>
          </div>
        </div>
        <div className='vdr-about-sheet-row'>
          <span className='vdr-icon-tile' aria-hidden='true'>
            <VisibilityOutlined />
          </span>
          <div>
            <h3 className='vdr-about-sheet-label'>Visión:</h3>
            <p className='public-about-us-page-text'>
              Nuestra visión es ser líderes en soluciones tecnológicas para la gestión de redes de
              distribución eléctricas a nivel nacional, ofreciendo a nuestros clientes herramientas
              para afrontar los desafíos de la transición energética. Aspiramos a proporcionar
              herramientas que apoyen a nuestros usuarios en la gestión de datos de
              infraestructura, la visibilidad de sus redes y recursos energéticos, la realización
              de estudios eléctricos detallados, la integración de recursos energéticos
              distribuidos y la toma de decisiones informada y con ello facilitar la planificación
              de sus redes y apoyar los cambios regulatorios que impulsen la transición energética
              y la descentralización.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Component02;
